export const useIntercomInstance = () => {
  const intercomInstance = window.Intercom;
  if (intercomInstance) {
    return intercomInstance;
  } else {
    return undefined;
  }
};
